import { render } from "./KontraktualSDABalai.vue?vue&type=template&id=7bf81b30"
import script from "./KontraktualSDABalai.vue?vue&type=script&lang=js"
export * from "./KontraktualSDABalai.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__